import React from 'react';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import NotFund_data_page from './NotFund_data_page';

const Not_fund_page = () => {
    return (
        <div>
            <Header></Header>
            <NotFund_data_page></NotFund_data_page>
            <Footer></Footer>
        </div>
    );
};

export default Not_fund_page;